import BranchFundingSourceHolidayEditComponent from './branch_funding_source_holiday.edit.component';

let BranchFundingSourceHolidayEditModule = angular.module('branchFundingSourceHolidayEdit', [])

.component('branchFundingSourceHolidayEdit', BranchFundingSourceHolidayEditComponent)

.name;

export default BranchFundingSourceHolidayEditModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/edit/index.js